module.exports = __webpack_public_path__ + "static/img/alterity2.638db88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/misc_3d/alterity/alterity2.jpg
// module id = iI24
// module chunks = 1